export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  types: state => {
    return state.types
  },
  categories: state => {
    return state.categories
  },
  entities: state => {
    return state.entities
  }
}
